import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapFormSection = React.lazy(function () {
    return import('../../bootstrap-components/components/BTFormSection');
});
var bootStrapFormSection = function (props) {
    return React.createElement(BootStrapFormSection, __assign({}, props));
};
var FormSection = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapFormSection(props);
            break;
        default:
            componentToDisplay = bootStrapFormSection(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
FormSection.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    name: 'FormSection'
};
export default FormSection;
//# sourceMappingURL=FormSection.js.map